import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { VisionboardItem } from "../../models";

@Injectable()
export class VisionboardItemFavoriteButtonMenuService {
  private _afterUnfavoriteSubject: Subject<VisionboardItem> = new Subject();
  afterUnfavorite$: Observable<VisionboardItem> = this._afterUnfavoriteSubject.asObservable();

  private _unfavoriteErrorSubject: Subject<VisionboardItem> = new Subject();
  unfavoriteError$: Observable<VisionboardItem> = this._unfavoriteErrorSubject.asObservable();

  private _favoritedClickSubject: Subject<VisionboardItem> = new Subject();
  favoritedClick$: Observable<VisionboardItem> = this._favoritedClickSubject.asObservable();

  private _unfavoritedClickSubject: Subject<VisionboardItem> = new Subject();
  unfavoritedClick$: Observable<VisionboardItem> = this._unfavoritedClickSubject.asObservable();

  constructor() {}

  afterUnfavorite(item: VisionboardItem): void {
    this._afterUnfavoriteSubject.next(item);
  }

  favoritedClick(item: VisionboardItem): void {
    this._favoritedClickSubject.next(item);
  }

  unfavoritedClick(item: VisionboardItem): void {
    this._unfavoritedClickSubject.next(item);
  }

  unfavoriteError(item: VisionboardItem): void {
    this._unfavoriteErrorSubject.next(item);
  }
}
